<template>
  <v-content>
    <v-container fluid>
      <v-layout row wrap>
        <v-flex push>
          <v-card class="primary">
            <v-card-title>
              <v-icon class="icon-space white--text" left>group</v-icon>
              <h5 class="title white--text">FIND GROUPS</h5>
              <v-spacer></v-spacer>
              <v-text-field
                dark
                append-icon="search"
                label="Search"
                single-line
                hide-details
                v-model="searchGroup"
              ></v-text-field>
            </v-card-title>
            <v-data-table 
              :headers="headersGroup"
              :items="groups"
              :search="searchGroup"
              :items-per-page-options='[5, 15, 25, { text: "All", value: -1 }]'
              class="secondary"
              >
                <template v-slot:item="{item}">
                  <tr class="clickable-row" @click="selectGroup(item.key)">
                    <td>{{item.name}}</td>
                    <td>{{item.email}}</td>
                  </tr>
                </template>
            </v-data-table>
            <v-card-text v-if="selectedGroup">
              <h1 class="white--text">{{selectedGroup.name}}</h1>
            </v-card-text>
          <v-list dense v-if="selectedGroup">
            <v-list-item
              v-for="(item, index) in selectedGroupMembers"
              :key="index"
            >
              <v-list-item-content>
                <v-list-item-title class="clickable-row dark-on-hover" @click="selectMemberFromEmail(item)" v-text="item"></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          </v-card>
        </v-flex>
        <v-flex push>
        <v-card class="primary">
          <v-card-title>
            <v-icon class="icon-space white--text" left>group</v-icon>
            <h5 class="title white--text">FIND PEOPLE</h5>
            <v-spacer></v-spacer>
            <v-text-field
              dark
              append-icon="search"
              label="Search"
              single-line
              hide-details
              v-model="searchEmail"
            ></v-text-field>
          </v-card-title>
          <v-data-table 
            :headers="headersPerson"
            :items="activePersons"
            :search="searchEmail"
            :items-per-page-options='[5, 15, 25, { text: "All", value: -1 }]'
            class="secondary"
          >
            <template v-slot:item="{item}">
              <tr class="clickable-row" @click="selectMember(item.key)">
                <td>{{item.fName}}</td>
                <td>{{item.lName}}</td>
                <td>{{item.email}}</td>
              </tr>
            </template>
          </v-data-table>
          <v-card-text v-if="selectedMember">
            <h1 class="white--text">{{selectedMember}}</h1>
          </v-card-text>
          <v-list dense v-if="selectedMember">
            <v-list-item
              v-for="(item, index) in selectedMemberships"
              :key="index"
            >
              <v-list-item-content>
                <v-list-item-title class="clickable-row dark-on-hover" @click="selectGroup(item.id)" v-text="item.name"></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
      
  </v-content>
</template>

<script>
import store from "@/store/";
import { setSelectedGroup, setSelectedMember } from "@/vue-service-groups.js";
import { getPersonsPushId } from "@/vue-service-selected_person";

export default {
  data() {
    return {
      searchGroup: "",
      searchEmail: "",
      headersGroup: [
        { text: "Name", value: "name" },
        { text: "Email", value: "email" }
      ],
      headersPerson: [
        { text: "First", value: "fName" },
        { text: "Last", value: "lName" },
        { text: "Email", value: "email" }
      ],
    }
  },
  computed: {
    selectedGroupKey() {
      return this.$store.getters.selectedGroupKey;
    },
    selectedGroup() {
      return this.$store.getters.selectedGroup;
    },
    selectedGroupMembers() {
      return this.$store.getters.selectedGroupMembers;
    },
    selectedMemberKey() {
      return this.$store.getters.selectedMemberKey;
    },
    selectedMember() {
      return this.$store.getters.selectedMember;
    },
    selectedMemberships() {
      return this.$store.getters.selectedMemberships;
    },
    activePersons() {
      let people = this.$store.getters.people;
      if(people === null) return [];
      return Object.keys(people).filter(key => people[key].active)
                                .map(key => Object.assign({key: key}, people[key]));
    },
    groups() {
      let groups = this.$store.getters.groups;
      if(groups === null) return [];
      return Object.keys(groups).map(key => Object.assign({key: key}, groups[key]));
    }
  },
  methods: {
    selectGroup(key) {
      setSelectedGroup(key);
    },
    selectMember(key) {
      setSelectedMember(key);
    },
    selectMemberFromEmail(email){
      let key = getPersonsPushId(email);
      setSelectedMember(key);
    }
  },
}
</script>
<style scoped>
.clickable-row{
  cursor: pointer;
}
.dark-on-hover{
  padding: 10px 20px;
  margin: -10px 0px;
}
.dark-on-hover:hover{
  background-color: rgba(0, 0, 0, 0.03);
}
</style>



// WEBPACK FOOTER //
// src/components/Groups/Groups.vue